import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { formSettings } from '../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import options from '../../../../../../text/selectOptions';
import { DateField, TextField, SelectField, PhoneField } from '../../../../../../components/fields';
import { required, email } from '../../../../../../utilities/validation';
import { normalizeAlphabetic, normalizeYear, isValidDateTime } from '../../../../../../utilities/validation';
import { autoFooler, getFullName } from '../../../../../../utilities/string';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { getUserBackgroundChecks, updateBackgroundCheck } from '../../../../../../reducers/backgroundCheck';
import { dateToFloatingString } from '../../../../../../utilities/dateTime';
import mixpanel from 'mixpanel-browser';
class BackgroundCheckAdditionalInfoStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'BackgroundCheckAdditionalInfoStep' } });

        const { user, backgroundCheck, getUserBackgroundChecks } = this.props;

        if (!backgroundCheck.id) {
            getUserBackgroundChecks(user && user.id);
        }
    }

    submit(values, action) {
        const { backgroundCheck, updateBackgroundCheck } = this.props;
        const { education, employment } = values;
        employment.start_date = dateToFloatingString(employment.start_date, 'YYYY-MM-DD');
        employment.end_date = dateToFloatingString(employment.end_date, 'YYYY-MM-DD');

        updateBackgroundCheck(backgroundCheck.id, { education, employment }, action);
    }

    sectionHead(label) {
        return (
            <div className="col-xs-12">
                <FormattedMessage {...label} tagName={'h5'} />
            </div>
        );
    }

    fieldRow(field1, field2 = null, field3 = null) {
        const col1class = field2 && field3 ? 'col-md-6 col-xs-12' : 'col-md-6 col-xs-12';
        const col23class = field2 && field3 ? 'col-md-3 col-xs-6' : 'col-md-6 col-xs-12';
        return (
            <div className="row">
                <div className="col-xs-12 col-lg-9">
                    <div className={col1class}>{field1}</div>
                    {field2 && <div className={col23class}>{field2}</div>}
                    {field3 && <div className={col23class}>{field3}</div>}
                </div>
            </div>
        );
    }

    fieldRow3(field1, field2, field3) {
        return (
            <div className="row">
                <div className="col-xs-12 col-lg-9">
                    <div className="col-md-4 col-sm-6">{field1}</div>
                    <div className="col-md-3 col-sm-6">{field2}</div>
                    <div className="col-md-5 col-sm-12">{field3}</div>
                </div>
            </div>
        );
    }

    fieldRow4(field1, field2, field3, field4) {
        const colClass = 'col-md-3 col-xs-6';
        return (
            <div className="row">
                <div className="col-xs-12 col-lg-9">
                    <div className={colClass}>{field1}</div>
                    <div className={colClass}>{field2}</div>
                    <div className={colClass}>{field3}</div>
                    <div className={colClass}>{field4}</div>
                </div>
            </div>
        );
    }

    renderShortAddress(fieldBase) {
        return this.fieldRow(
            <Field
                name={`${fieldBase}.address.city`}
                validate={required}
                component={TextField}
                placeholder={messages.city}
                autoComplete={autoFooler('city')}
            />,
            <Field
                name={`${fieldBase}.address.state`}
                validate={required}
                component={SelectField}
                options={options.states}
                placeholder={messages.state}
                autoComplete={autoFooler('state')}
            />,
            <Field
                name={`${fieldBase}.address.country`}
                validate={required}
                normalize={normalizeAlphabetic}
                component={TextField}
                placeholder={messages.country}
                autoComplete={autoFooler('country')}
            />
        );
    }

    // name, school_url, address(city, state, country)
    // degree, major
    // name_on_diploma, year_awarded, current
    renderEducation() {
        const { selectedCurrentlyEnrolled } = this.props;
        const gradYearLabel = selectedCurrentlyEnrolled === 'true' ? messages.yearExpected : messages.yearCompleted;

        return (
            <div className="row section">
                {this.sectionHead(messages.educationVerification)}

                {this.fieldRow(<Field name="education.name_on_diploma" validate={required} component={TextField} placeholder={messages.nameOnDiploma} />)}
                {this.fieldRow(
                    <Field name="education.name" validate={required} component={TextField} placeholder={messages.schoolName} />,
                    <Field name="education.school_url" validate={required} component={TextField} placeholder={messages.schoolWebsite} />
                )}
                {this.renderShortAddress('education')}
                {this.fieldRow4(
                    <Field name="education.degree" validate={required} component={TextField} placeholder={messages.schoolDegree} />,
                    <Field name="education.major" validate={required} component={TextField} placeholder={messages.schoolMajor} />,
                    <Field name="education.current" component={SelectField} options={options.enrolledOptions} placeholder={messages.degreeStatus} />,
                    <Field name="education.year_awarded" validate={required} component={TextField} placeholder={gradYearLabel} normalize={normalizeYear} />
                )}
            </div>
        );
    }

    // name, employer_url
    // address (city, state, country)
    // position, contract_type
    // start_date, end_date
    // do_not_contact
    // manager(email, name, phone, title)
    renderEmployment() {
        const { selectedStartDate, selectedEndDate } = this.props;
        return (
            <div className="row section">
                {this.sectionHead(messages.employmentVerification)}
                {this.fieldRow(
                    <Field
                        name="employment.name"
                        component={TextField}
                        validate={required}
                        placeholder={messages.mostRecentEmployer}
                        autoComplete={autoFooler('company')}
                    />,
                    <Field name="employment.employer_url" component={TextField} placeholder={messages.companyURL} autoComplete={autoFooler('companyURL')} />
                )}
                {this.renderShortAddress('employment')}
                {this.fieldRow(
                    <Field
                        name="employment.position"
                        component={TextField}
                        validate={required}
                        placeholder={messages.position}
                        autoComplete={autoFooler('company')}
                    />,
                    <Field name="employment.contract_type" component={SelectField} options={options.contractOptions} placeholder={messages.contractType} />
                )}
                {this.fieldRow(
                    <Field
                        name="employment.start_date"
                        selectedDate={selectedStartDate ? selectedStartDate : null}
                        validate={[required, isValidDateTime]}
                        component={DateField}
                        placeholder={messages.approxStartDate}
                    />,
                    <Field
                        name="employment.end_date"
                        selectedDate={selectedEndDate ? selectedEndDate : null}
                        validate={isValidDateTime}
                        component={DateField}
                        placeholder={messages.approxEndDate}
                    />
                )}
                {this.fieldRow(
                    <Field name="employment.manager.name" component={TextField} placeholder={messages.manager} autoComplete={autoFooler('manager')} />,
                    <Field name="employment.manager.title" component={TextField} placeholder={messages.title} autoComplete={autoFooler('managerTitle')} />
                )}
                {this.fieldRow(
                    <Field
                        name="employment.manager.email"
                        component={TextField}
                        placeholder={messages.managerEmail}
                        validate={email}
                        autoComplete={autoFooler('managerEmail')}
                    />,
                    <Field name="employment.manager.phone" component={PhoneField} placeholder={messages.phone} autoComplete={autoFooler('managerPhone')} />
                )}
            </div>
        );
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, backgroundCheck, client } = this.props;
        if (!client || !backgroundCheck) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'backgroundCV.intro'}
                            defaultMessage={
                                '{co} requires verification of your education and employment history.  Please provide information about your highest degree obtained and your most recent employer.'
                            }
                            values={{ co: client.name }}
                        />
                    </div>
                </div>
                {this.renderEducation()}
                {this.renderEmployment()}
                <WizardButtons disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

function nonEmptyAddress(address) {
    const country = 'US';
    if (address && address.country) return address;
    if (address) return { ...address, country };
    return { country };
}

BackgroundCheckAdditionalInfoStep = reduxForm(formSettings)(BackgroundCheckAdditionalInfoStep);

const selector = formValueSelector(formSettings.form);
const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    const backgroundCheck = state.backgroundCheck.current;
    const user = state.identity.profile;

    const education = (backgroundCheck && backgroundCheck.education) || {};
    const employment = (backgroundCheck && backgroundCheck.employment) || {};
    education.name_on_diploma = education.name_on_diploma || getFullName(user);
    education.address = nonEmptyAddress(education.address);
    education.current = education.current || 'false';
    employment.address = nonEmptyAddress(employment.address);
    employment.contract_type = employment.contract_type || 'full_time';

    return {
        selectedCurrentlyEnrolled: selector(state, 'education.current'),
        selectedStartDate: selector(state, 'employment.start_date'),
        selectedEndDate: selector(state, 'employment.end_date'),
        role: state.identity.role,
        job: state.onboarding.job,
        client: state.onboarding.client,
        progression,
        backgroundCheck,
        initialValues: { education, employment },
        user
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setProgressionProperties,
            getUserBackgroundChecks,
            updateBackgroundCheck
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCheckAdditionalInfoStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/backgroundCheckAdditionalInfo.jsx